import { DetailDateFormatter, NameFormatter } from '../../../shared/controls/formatters';
import { useEffect, useRef, useState } from 'react';
import apiServices from '../../../services/service';
import { fetchNotesAndAppendToModule } from '../../../redux/actions';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import NoteForm from './noteForm';
import { Button, Modal } from 'react-bootstrap';

const Notes = ({ leadLocalData, module, handleSubmitNote }) => {
  console.log('leadLocalData=======', leadLocalData);
  const [errormsg, setErrorMsg] = useState({});
  const [noteData, setNoteData] = useState({ title: '', description: '', type: 'add' });
  const [noteDataEdited, setNoteDataEdited] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPopup6, setShowPopup6] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [selectedNote, setSelectedNote] = useState([]);

  const dispatch = useDispatch();

  const handleSubmit = async (noteData) => {
    setLoading(true);
    const updatedNoteData = {
      ...noteData,
      moduleId: leadLocalData?.id,
      module: module,
    };
    setNoteDataEdited(false);
    if (updatedNoteData.type === 'edit') {
      apiServices
        .updateNote(updatedNoteData)
        .then((response) => {
          if (response.status === 200) {
            handleClosePopUp();
            // updateList("Form submitted successfully!");
            setNoteData({ title: '', description: '', type: 'add' });
            dispatch(
              fetchNotesAndAppendToModule({
                moduleName: module,
                id: leadLocalData?.id,
              })
            );
            setLoading(false);
            // getList();
            toast.success('Notes Updated successfully!', {
              position: 'top-right',
            });
          } else {
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })

        .catch((error) => {
          toast.error('An unexpected error occurred.', {
            position: 'top-right',
          });
          setLoading(false);
        });
    } else {
      apiServices
        .createNote(updatedNoteData)
        .then((response) => {
          if (response.status === 200) {
            setNoteData({ title: '', description: '', type: 'add' });
            dispatch(
              fetchNotesAndAppendToModule({
                moduleName: module,
                id: leadLocalData?.id,
              })
            );
            setLoading(false);
            toast.success('Notes Added successfully!', {
              position: 'top-right',
            });
          } else {
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })

        .catch((error) => {
          toast.error('An unexpected error occurred.', {
            position: 'top-right',
          });
          setLoading(false);
        });
    }
  };
  const handleChangeFormNote = (e) => {
    const { name, value } = e.target;
    const convertedValue = value;
    setNoteData((prevNoteData) => ({
      ...prevNoteData,
      [name]: value,
    }));
    setNoteDataEdited(true);
  };

  const handleClosePopUp = () => {
    setShowPopup6(false);
  };

  const handleOpenPopUp = () => {
    setShowPopup6(true);
  };

  const openPopup6 = (data) => {
    const updatedObject = {
      ...data,
      firstName: leadLocalData.firstName,
      lastName: leadLocalData.lastName,
      type: 'edit',
    };
    setNoteData(updatedObject);
    handleOpenPopUp();
  };
  // Function to close the sixth popup
  const handlePopupDelete = (note) => {
    setSelectedNote(note); // Store the note to delete
    setDeletePopup(true); // Open the delete confirmation popup
  };

  const handleClickDelete = (paramsValue) => {
    setLoading(true);
    // Creating the desired JSON object
    const data = {
      id: paramsValue.id,
      module: module,
      moduleId: leadLocalData?.id
    };
    console.log('Data==>>', data);
    apiServices
      .deleteNote(data)
      .then((response) => {
        if (response.status === 200) {
          dispatch(
            fetchNotesAndAppendToModule({
              moduleName: module,
              id: leadLocalData?.id,
            })
          );
          setLoading(false);
          setDeletePopup(false);
          toast.success('Note Deleted Successfully!', {
            position: 'top-right',
          });
        }
      })
      .catch((error) => {
        console.error('Error while deleting lead:', error);
        setLoading(false);
        setDeletePopup(false);
      });
  };

  const notescontainerRef = useRef(null);

  useEffect(() => {
    if (notescontainerRef.current) {
      notescontainerRef.current.scrollTop = notescontainerRef.current.scrollHeight;
    }
  }, [leadLocalData?.notesList]);

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="addlead-header pd_card">
            <label htmlFor="" className="flex-div align-items-center">
              <img className="me-2" src="../assets/images/notesIcon.svg" alt="" />
              Notes
            </label>
          </div>
          <div className="leadcontent ">
            <>
              <div className="row">
                <div className="col-12 NotesContent" ref={notescontainerRef}>
                  <div className="row">
                    {!leadLocalData?.notesList && (
                      <div className="col-12 col-md-12">Loading...</div>
                    )}
                    {leadLocalData?.notesList?.length > 0 &&
                      leadLocalData?.notesList.map((data, i) => (
                        <div key={'notes-' + i} className="col-12 col-md-12">
                          <div className="notesDes">
                            <div className="notestHDr mb-2"></div>

                            <div className="actionRowNotes">
                              <div className="leadRow mb-2">
                                {' '}
                                <span className="notesTitle">{data.title}</span>
                              </div>
                              <div className="addNote mb-2">
                                {data?.description ? `${data.description}` : ' '}
                              </div>
                              <div className="notesFtr">
                                <div className="d-flex align-items-center gap-2">
                                  <span
                                    className="badge rounded-pill badge-light-yellow small"
                                    style={{
                                      background: '#89aede',
                                      color: '#3d3b6d',
                                      fontSize: '0.65rem ',
                                      fontWeight: '500',
                                    }}
                                  >
                                    {module === 'Account' ? data?.relatedModule : module}
                                  </span>
                                  <span className="badge rounded-pill badge-light-blue small">
                                    {DetailDateFormatter(data.updatedDateTime)}
                                  </span>
                                </div>
                              </div>
                              <div className="d-flex align-items-center gap-2 mt-2 justify-content-between">
                                <p className="submitedBy mb-0">
                                  by {NameFormatter(data.createdBy)}.
                                </p>
                                <div className="actionButton " id="addnote_popup">
                                  <img
                                    style={{ cursor: 'pointer' }}
                                    src="/assets/images/editNotes.svg"
                                    alt="Edit Notes"
                                    width="14px"
                                    onClick={() => openPopup6(data)}
                                  />

                                  <img
                                    style={{ cursor: 'pointer' }}
                                    src="/assets/images/deleteNotes.svg"
                                    alt="Delete Notes"
                                    width="14px"
                                    onClick={() => handlePopupDelete(data)} // Replace with actual note data
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    <div className="col-12 col-md-12">
                      <div className="actionRow">
                        <div className="actionButton" id="addnote_popup"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="noteForm">
                  <NoteForm
                    moduleId={leadLocalData?.id}
                    module={module}
                    noteData={noteData}
                    handleChangeFormNote={handleChangeFormNote}
                    handleSubmit={handleSubmit}
                    noteDataEdited={noteDataEdited}
                    loading={loading}
                  />
                </div>
              </div>
            </>
          </div>
        </div>
      </div>
      {deletePopup && (
        <Modal show={deletePopup} onHide={() => setDeletePopup(false)} className="modal-delete">
          <Modal.Header closeButton>
            <Modal.Title>Confirm Deletion</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to delete this note?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setDeletePopup(false)}>
              Cancel
            </Button>
            <Button variant="danger" onClick={() => handleClickDelete(selectedNote)}>
              Confirm Delete
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};
export default Notes;
